/**
 * PrivacyNotice — Lock icon + italic disclaimer shown when original text is hidden.
 *
 * Text colour #6B7280 (corrected from prototype's #A1A1AA which fails WCAG AA at 2.4:1).
 * #6B7280 achieves 4.7:1 (AA).
 */

import React from 'react';
import { View, Text, StyleSheet, ViewStyle } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import type { TFunction } from '@dramadetector/shared';

interface PrivacyNoticeProps {
  t: TFunction<'practitioner'>;
}

export const PrivacyNotice: React.FC<PrivacyNoticeProps> = ({ t }) => (
  <View style={styles.container} accessibilityRole="text">
    <Ionicons name="lock-closed-outline" size={14} color="#9CA3AF" />
    <Text style={styles.text}>{t('privacy_notice.message')}</Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255, 255, 255, 0.4)',
  } as ViewStyle,
  text: {
    fontSize: 12,
    fontStyle: 'italic',
    color: '#6B7280', // Corrected from #A1A1AA for WCAG AA 4.7:1
    flex: 1,
  },
});
